import React from 'react';
import './AboutOutreach.css';

export default function AboutIITD() {
    const points = [
        { title: "Connections", text: "Establish meaningful and impactful connections with academic peers and the broader society." },
        { title: "Dissemination", text: "Disseminate scientific and technological advancements through structured outreach programs." },
        { title: "Collaboration", text: "Facilitate a two-way exchange of knowledge to enhance research quality and methodologies." },
        { title: "Impact", text: "Address critical societal challenges while promoting awareness of science and technology." }
    ];

    return (
        <div className="about_outreach">
            <h2>About <span>Academic Outreach IIT Delhi</span></h2>
            <div className="about_outreach_container">
                {points.map((point, index) => (
                    <div key={index} className="about_outreach_box">
                        <h3 className="about_outreach_title">{point.title}</h3>
                        <p className="about_outreach_text">{point.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
